import { useState } from 'react'

const useOpenClose = (initialState) => {
  const [isOpen, setIsOpen] = useState(initialState)
  const isClose = !isOpen
  const handleClose = () => setIsOpen(false)
  const handleOpen = () => setIsOpen(true)
  const handleReset = () => setIsOpen(initialState)

  return { isOpen, isClose, handleClose, handleOpen, handleReset }
}
export default useOpenClose
